/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Filter_Date_RangeInputs */

const en_dashboard_filter_date_range = /** @type {(inputs: Dashboard_Filter_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by creation period`)
};

const pt_br2_dashboard_filter_date_range = /** @type {(inputs: Dashboard_Filter_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por período de criação`)
};

/**
* | output |
* | --- |
* | "Filter by creation period" |
*
* @param {Dashboard_Filter_Date_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_filter_date_range = /** @type {((inputs?: Dashboard_Filter_Date_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Filter_Date_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_filter_date_range(inputs)
	return pt_br2_dashboard_filter_date_range(inputs)
});